import { privateApi } from 'services';
import {
    BusinessAccountChannel,
    CreateBusinessAccountChannel,
    ConnectWhatsAppRequest,
    ConnectSmsRequest,
} from './types';

const syncChannels = (businessAccountId: string): Promise<void> =>
    privateApi.post<void>(`business-accounts/${businessAccountId}/bird/channels/sync`, {});

const connectWhatsApp = (businessAccountId: string, connectRequest: ConnectWhatsAppRequest): Promise<void> =>
    privateApi.post<void>(`business-accounts/${businessAccountId}/bird/whatsapp/connect`, connectRequest);

const connectSms = (businessAccountId: string, connectRequest: ConnectSmsRequest): Promise<void> =>
    privateApi.post<void>(`business-accounts/${businessAccountId}/bird/sms/connect`, connectRequest);

export const BusinessAccountChannelGateway = {
    syncChannels,
    connectWhatsApp,
    connectSms,
};
